import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BiMailSend } from 'react-icons/bi';
import { FaEye } from 'react-icons/fa';
import { BsFileEarmarkArrowDown } from 'react-icons/bs';
import AnimatedModal from './AnimatedModal';

interface CandidatosModalProps {
  show: boolean;
  onClose: () => void;
  processo: any;
}

const CandidatosModal: React.FC<CandidatosModalProps> = ({ show, onClose, processo }) => {
  const navigate = useNavigate();

  if (!show) return null;

  const handleVisualizarCandidatos = () => {
    onClose();
    navigate(`/processos/${processo.id}/candidatos`, { state: { processoId: processo.id } });
  };

  const handleEnviarEmail = () => {
    onClose();
    navigate(`/processos/${processo.id}/email-candidatos-heteroidentificacao`);
  };

  const handleGerenciarCandidatos = () => {
    onClose();
    navigate(`/processos/${processo.id}/candidatos/upload`, { state: { processoId: processo.id } });
  };

  return (
    <AnimatedModal isOpen={show} onClose={onClose}>
      <div className="modal-content" style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px',
        minWidth: '400px',
        maxWidth: '500px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
      }}>
        <div className="modal-header" style={{
          borderBottom: '1px solid #e9ecef',
          paddingBottom: '16px',
          marginBottom: '20px'
        }}>
          <h3 style={{ margin: 0, fontSize: '18px', fontWeight: '600' }}>
            Candidatos de {processo.nome}
          </h3>
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              background: 'none',
              border: 'none',
              fontSize: '20px',
              cursor: 'pointer',
              color: '#6c757d'
            }}
          >
            ×
          </button>
        </div>

        <div className="modal-body" style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '12px'
        }}>
          <button
            onClick={handleVisualizarCandidatos}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 16px',
              border: '1px solid #dee2e6',
              borderRadius: '6px',
              backgroundColor: '#f8f9fa',
              cursor: 'pointer',
              fontSize: '14px',
              position: 'relative'
            }}
          >
            <FaEye />
            <span>Visualizar Candidatos</span>
            {processo.numeroCandidatos > 0 && (
              <span style={{
                position: 'absolute',
                right: '12px',
                color: 'green',
                fontWeight: 'bold'
              }}>✓</span>
            )}
          </button>

          <button
            onClick={handleEnviarEmail}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 16px',
              border: '1px solid #dee2e6',
              borderRadius: '6px',
              backgroundColor: '#f8f9fa',
              cursor: 'pointer',
              fontSize: '14px',
              position: 'relative'
            }}
          >
            <BiMailSend />
            <span>Email de Heteroidentificação</span>
            {processo.convocacoesEnviadas && processo.numeroCandidatos > 0 && (
              <span style={{
                position: 'absolute',
                right: '12px',
                color: 'green',
                fontWeight: 'bold'
              }}>✓</span>
            )}
          </button>

          <button
            onClick={handleGerenciarCandidatos}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              padding: '12px 16px',
              border: '1px solid #dee2e6',
              borderRadius: '6px',
              backgroundColor: '#fff3cd',
              cursor: 'pointer',
              fontSize: '14px',
              position: 'relative'
            }}
          >
            <BsFileEarmarkArrowDown />
            <span>Gerenciar Candidatos do Processo</span>
            {processo.numeroCandidatos > 0 && (
              <span style={{
                position: 'absolute',
                right: '12px',
                color: 'green',
                fontWeight: 'bold'
              }}>✓</span>
            )}
          </button>
        </div>

        <div className="modal-footer" style={{
          borderTop: '1px solid #e9ecef',
          paddingTop: '16px',
          marginTop: '20px',
          display: 'flex',
          justifyContent: 'flex-end'
        }}>
          <button
            onClick={onClose}
            style={{
              padding: '8px 16px',
              border: '1px solid #dc3545',
              borderRadius: '4px',
              backgroundColor: '#dc3545',
              color: 'white',
              cursor: 'pointer',
              fontSize: '14px'
            }}
          >
            Fechar
          </button>
        </div>
      </div>
    </AnimatedModal>
  );
};

export default CandidatosModal;